export default __webpack_public_path__ + "static/media/Trending.c8ad171e.png";